import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Image, Box, Text, Button } from '@chatterbug/aaron'
import { Modal } from '@chatterbug/aaron/modal'
import { t } from 'src/lib/i18n-react'

import { customModalStyle } from '../utils'

import units from './assets/units.svg'

const AddUnitModal = ({ isOpen, onHide, onClick }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onHide}
      title={t('Create your course')}
      style={customModalStyle}
    >
      <Text mb="2x" textAlign="center" data-testid="modal-text">
        {t(
          "Before you can book a lesson, you need to choose what topics you'd like to work on."
        )}
      </Text>
      <Flex alignItems="center" flexDirection="column">
        <Box mb="3x">
          <Image src={units} />
        </Box>
        <Button
          data-testid="create-course-button"
          type="primaryAdvanced"
          onClick={onClick}
        >
          {t('Create my course')}
        </Button>
      </Flex>
    </Modal>
  )
}
AddUnitModal.propTypes = {
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}

export default AddUnitModal
